import { FC } from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import SimpleModalNew from 'components/Modal';
import { BoilerplateModalProps } from './types';
import { RowStack, IconButtonCommon } from 'components/styled';
import { StyledModalHeaderIconContainer } from './styled';
import CloseIcon from '@mui/icons-material/Close';

const BoilerplateModal: FC<BoilerplateModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  width = '886px',
  height,
  maxWidth,
  headerIcon,
  headerIconComponent,
  removeHeaderIcon = false,
  footerPadding = '20px 32px',
  headerComponent,
  bodyHeight,
  bodyPadding = '20px 32px',
  removeHeader = false,
}) => {
  return (
    <SimpleModalNew isOpen={isOpen} handleClose={onClose} width={width} maxWidth={maxWidth} height={height}>
      <Stack divider={<Divider flexItem />}>
        {/* Header */}
       {removeHeader ? null : <RowStack fullWidth padding={'16px 32px'} gap={'16px'} alignCenter>
          {headerIconComponent ||
            (!removeHeaderIcon && <StyledModalHeaderIconContainer>{headerIcon}</StyledModalHeaderIconContainer>)}
          <Typography variant='labelMedium' flex={1}>
            {title}
          </Typography>
          {headerComponent}
          <IconButtonCommon onClick={onClose}>
            <CloseIcon sx={{ height: '24px', width: '24px' }} />
          </IconButtonCommon>
        </RowStack>}
        {/* Body */}
        <Stack padding={bodyPadding} overflow={'auto'} height={bodyHeight}>
          {children}
        </Stack>
        {/* Footer */}
        {footer && (
          <Stack padding={footerPadding} gap={'16px'}>
            {footer}
          </Stack>
        )}
      </Stack>
    </SimpleModalNew>
  );
};

export default BoilerplateModal;
